export default __webpack_public_path__ + "static/media/qr-code.0d1efb4c.svg";